import { Text, Box } from '@machobear/design-system'
import AreaTitle from '@/components/area-title'

const HeaderLayout = ({ title, description = '' }) => {
  return (
    <Box marginBottom="large">
      <AreaTitle textAlign="left" top="0" bottom="0">
        {title}
      </AreaTitle>
      {!!description && (
        <Box marginTop="small">
          <Text tone="secondary" size="small">
            {description}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default HeaderLayout
